'use strict'
import { request } from '../../plugins/http'

export default async (data) => {
    return data.name 
        ? await request.get('/responsavelAtendimento', {params:data})
        : await request.get('/responsavelAtendimento', {params: { companyId: data.companyId, name: '' }})
}